import { toSafeUrl } from '@karakuri-web/common/utils'
import { IframeLayout } from '@karakuri-web/faq-type'

interface Props {
  layout: IframeLayout
}

/**
 * Iframeウィジェット
 * 外部コンテンツをiframeで表示する
 */
export function IframeWidget({ layout }: Props) {
  // javascript: の src は親（faq-preview では管理画面）のオリジンで実行されるため、http(s) のURLだけ表示する
  const src = toSafeUrl(layout.data, ['http:', 'https:'])
  // eslint-disable-next-line jsx-a11y/iframe-has-title
  return src ? <iframe className={'faq-iframe'} src={src} /> : null
}
